/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { WorkspaceTrainingProjectFragmentDoc, TrainingJobByStatusCountFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrainingProjectsQueryVariables = Types.Exact<{
  teamId?: Types.InputMaybe<Types.Scalars['String']>;
  all?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type TrainingProjectsQuery = { __typename?: 'QueryPrediction', trainingProjects: Array<{ __typename?: 'TrainingProject', id: string, name: string, created: any, modified: any, lastActivity: string | null | undefined, user: { __typename?: 'UserType', id: string, name: string | null | undefined }, jobsCountByStatus: Array<{ __typename?: 'TrainingJobByStatusCount', status: string, count: number } | null | undefined>, team: { __typename?: 'TeamType', id: string, name: string, icon: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };


export const TrainingProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingProjects"},"name":{"kind":"Name","value":"training_projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceTrainingProjectFragment"}}]}}]}},...WorkspaceTrainingProjectFragmentDoc.definitions,...TrainingJobByStatusCountFragmentDoc.definitions]} as unknown as DocumentNode<TrainingProjectsQuery, TrainingProjectsQueryVariables>;
export const namedOperations = {
  Query: {
    TrainingProjects: 'TrainingProjects'
  }
}

/**
 * __useTrainingProjectsQuery__
 *
 * To run a query within a React component, call `useTrainingProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingProjectsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useTrainingProjectsQuery(baseOptions?: Apollo.QueryHookOptions<TrainingProjectsQuery, TrainingProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingProjectsQuery, TrainingProjectsQueryVariables>(TrainingProjectsDocument, options);
      }
export function useTrainingProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingProjectsQuery, TrainingProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingProjectsQuery, TrainingProjectsQueryVariables>(TrainingProjectsDocument, options);
        }
export type TrainingProjectsQueryHookResult = ReturnType<typeof useTrainingProjectsQuery>;
export type TrainingProjectsLazyQueryHookResult = ReturnType<typeof useTrainingProjectsLazyQuery>;
export type TrainingProjectsQueryResult = Apollo.QueryResult<TrainingProjectsQuery, TrainingProjectsQueryVariables>;
export function refetchTrainingProjectsQuery(variables?: TrainingProjectsQueryVariables) {
      return { query: TrainingProjectsDocument, variables: variables }
    }